export const HasTouch = {
  data: () => ({
    lastTouchTime: 0,
  }),

  mounted() {
    document.addEventListener('touchstart', this.onTouchStart);
    document.addEventListener('mousemove', this.onMouseMove);
  },
  beforeDestroy() {
    document.removeEventListener('touchstart', this.onTouchStart);
    document.removeEventListener('mousemove', this.onMouseMove);
  },
  methods: {
    onMouseMove() {
      if (new Date() - this.lastTouchTime > 500) document.body.classList.remove('hasTouch');
    },
    onTouchStart() {
      this.lastTouchTime = Date.now();
      document.body.classList.add('hasTouch');
    },
  },
};
